export const CRUD_CODES = ['VIEW', 'CREATE', 'EDIT', 'DELETE'];

/** Access Control (RBAC) module — each admin screen is its own submodule page. */
export const ACCESS_KEYS = {
  ROLES_VIEW: 'RBAC.ROLES.VIEW',
  ROLES_CREATE: 'RBAC.ROLES.CREATE',
  ROLES_EDIT: 'RBAC.ROLES.EDIT',
  MATRIX_VIEW: 'RBAC.PERMISSION_MATRIX.VIEW',
  MATRIX_EDIT: 'RBAC.PERMISSION_MATRIX.EDIT',
  CATALOG_VIEW: 'RBAC.MODULES_PAGES.VIEW',
  CATALOG_CREATE: 'RBAC.MODULES_PAGES.CREATE',
  CATALOG_EDIT: 'RBAC.MODULES_PAGES.EDIT',
  PREVIEW_VIEW: 'RBAC.PREVIEW.VIEW',
  AUDIT_VIEW: 'RBAC.AUDIT.VIEW',
};

const bySort = (a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0) || String(a.name).localeCompare(String(b.name));

/**
 * Catalog -> antd tree rows: module rows with nested page rows.
 * Each page row carries its permissions (CRUD + buttons).
 */
export const buildCatalogTree = catalog => {
  if (!catalog) return [];
  const permsByPage = {};
  (catalog.permissions || []).forEach(p => {
    (permsByPage[p.pageId] = permsByPage[p.pageId] || []).push(p);
  });

  const pageRows = (moduleId, parentId) =>
    (catalog.pages || [])
      .filter(p => p.moduleId === moduleId && (p.parentPageId ?? null) === parentId)
      .sort(bySort)
      .map(page => {
        const children = pageRows(moduleId, page.id);
        return {
          key: `p-${page.id}`,
          type: 'page',
          page,
          perms: permsByPage[page.id] || [],
          children: children.length ? children : undefined,
        };
      });

  return (catalog.modules || [])
    .slice()
    .sort(bySort)
    .map(module => {
      const children = pageRows(module.id, null);
      return {
        key: `m-${module.id}`,
        type: 'module',
        module,
        children: children.length ? children : undefined,
      };
    });
};

/** All page rows below a tree node (inclusive when the node is a page). */
export const collectPageRows = node => {
  const out = [];
  const walk = n => {
    if (n.type === 'page') out.push(n);
    (n.children || []).forEach(walk);
  };
  walk(node);
  return out;
};

export const permissionIdsOf = node => collectPageRows(node).flatMap(r => r.perms.map(p => p.id));
